import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LicensesStoreModule } from 'mbs-ui-shared@store/licenses';
import { metaReducers } from 'mbs-ui-shared@store/meta.reducers';
import { EventStoreModule } from 'mbs-ui-shared@store/rmmEvent/event-store.module';
import { RmmGroupActionWizardStoreModule } from 'mbs-ui-shared@store/rmmGroupActionWizard/store.module';
import { RmmGroupTasksStoreModule } from 'mbs-ui-shared@store/rmmGroupTasks/store.module';
import { RmmScriptLibraryStoreModule } from 'mbs-ui-shared@store/rmmScriptLibrary/store.module';

@NgModule({
  imports: [
    StoreModule.forRoot(
      {},
      {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true
        }
      }
    ),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true
    }),
    RmmGroupActionWizardStoreModule,
    RmmGroupTasksStoreModule,
    RmmScriptLibraryStoreModule,
    EventStoreModule,
    LicensesStoreModule
  ]
})
export class AppStoreModule {}
